import { TranslationMessages } from 'react-admin';
// import spanishMessages from './spanishMessages'
import spanishMessages from "@blackbox-vision/ra-language-spanish";
import spanishImportMessages from "react-admin-import-csv/lib/i18n/es";

const customSpanishMessages: TranslationMessages = {
  ...spanishMessages,
  ...spanishImportMessages,
  pos: {
    search: 'Buscar',
    save: 'Guardar',
    cancel: 'Cancelar',
    copy_clipboard: 'Copiar al Portapapeles',
    configuration: 'Configuración',
    language: 'Idioma',
    theme: {
      name: 'Tema',
      light: 'Claro',
      dark: 'Oscuro (Beta)',
    },
    dashboard: {
      transactions: 'Transactions',
      welcome: {
        title: 'Bienvenido al admin de R2 Capital',
        subtitle:
          "Financiamiento rápido y flexible desde tu plataforma, sin riesgo para ti",
        home_button: 'Sitio principal de R2 Capital',
        src_button: 'Código fuente',
      },
    },
    menu: {
      Merchant: 'Negocios',
    },
  },
  resources: {
    common: {
      fields: {
        updated_at: 'Actualizado',
        created_at: 'Creado',
        "created_at@_gte": "Creado mayor a",
        "created_at@_lte": "Creado menor a",
        "updated_at@_gte": "Actualizado mayor a",
        "updated_at@_lte": "Actualizado menor a",
        "collected_at@_gte": "Registrado mayor a",
        "collected_at@_lte": "Registrado menor a",
        id: "ID",
        savings: 'Ahorros',
        checking: 'Corriente',
        'moral_person': 'Moral',
        'natural_person': 'Natural',
        'home': 'Inicio',
        'home_letter': '',
        'Merchant_letter': '',
        'Financing_letter': '',
        'Platform_letter': '',
        'Transaction_letter': '',
        'FinancialRegimen_letter': '',
        'collections_letter': '',
        'merchants_letter': '',
        'offers_letter': '',
        'financings_letter': '',
      },
      fieldGroups: {
        history: 'Historia',
        info: 'Información',
        basicInfo: 'Información Básica',
        otherInfo: 'Otra Información',
        accountInfo: 'Información de Cuentas',
        operativeInfo: 'Información Operativa',
        phones: 'Teléfonos',
        docs: 'Documentos'
      },
      labels: {
        lastN: 'últimos %{num} elementos'
      }
    },
    MerchantSales: {
      name: 'Ventas Negocios'
    },
    Merchant: {
      name: 'Negocio |||| Negocios',
      title: 'Negocio %{reference}',
      links: {
        transactions: 'Transacciones',
        offers: 'Ofertas',
        financings: 'Financiamientos',
        docLink: 'Link al Documento',
      },
      dashboard: {
        liquidated: 'Liquidado',
        balanceTitle: 'Balance',
        detailTitle: 'Detalle',
        salesTitle: 'Ventas y liquidaciones',
        balance: 'Saldo',
        financing_id: 'ID financiamiento',
        capital_received: 'Capital Recibido',
        cost: 'Costo',
        liquidated_total: 'Total a liquidar',
        liquidated_total_vat: 'Total a liquidar + IVA',
        sales_percentage: 'Porcentaje de ventas',
        date: 'Fecha venta',
        gross_sale: 'Lo que vendiste',
        repayment: 'Liquidación',
        vat_total: 'IVA',
        transfer_to_merchant: 'Lo que te transferimos',
        transfer: 'Lo que te transferimos',
        financing_date: 'Fecha inicio',
        limit_date: 'Fecha límite',
      },
      fields: {
        id: "ID",
        name: 'Nombre',
        platform: 'Plataforma',
        platform_id: 'Plataforma',
        financialRegimen: 'Régimen Financiero',
        financialRegimenId: 'Régimen Financiero',
        industry: 'Industria',
        financings: 'Financiamientos',
        financingsText: '%{id}',
        metadata: {
          country: 'País',
          legal_name: 'Nombre legal',
          person_type: 'Tipo de persona',
          email: 'Email',
          account: 'Cuenta',
          account_type: 'Tipo de cuenta',
          bank: 'Banco',
          bank_id: 'Banco',
          beneficiary_account: 'Beneficiario cuenta',
          clabe: 'CLABE',
          curp: 'CURP',
          clave_elector: 'Clave elector',
          passport: 'Pasaporte',
          rfc: 'RFC',
          residence: 'Domicilio',
          ruc: 'RUC',
          phone: 'Teléfono',
          ecuador_id: 'Identificación Ecuador',
          'rappi_bank_id': 'ID Banco Rappi',
          'rappi_id': 'Rappi ID',
          'srpago_id': 'Sr Pago ID',
          'clip_id': 'Clip ID',
          'pideaky_id': 'Pideaky ID',
          rappi: {
            brand_ids: 'Rappi brand IDs'
          },
        },
      }
    },
    merchants: {
      name: 'Negocio |||| Negocios',
      links: {
        collections: 'Collections',
        offers: 'Ofertas',
        financings: 'Financiamientos',
        docLink: 'Link al Documento',
      },
      fields: {
        financings: 'Financiamientos',
        email: 'Email',
        name: 'Nombre',
        industry: 'Industria',
        'registration_month@_lte': 'Registro menor que',
        'registration_month@_gte': 'Registro menor que',
        'data.registration_month': 'Registro'
      }
    },
    Financing: {
      name: 'Financiamiento |||| Financiamientos',
      title: 'ID %{reference}',
      links: {
        merchant: 'Negocio',
        transactions: 'Transacciones',
        offer: 'Oferta',
        viewStatement: 'Ver declaración'
      },
      fields: {
        id: "ID",
        amount: 'Cantidad',
        currency: 'Moneda',
        country: 'País',
        state: 'Estado',
        type: 'Tipo',
        fixed_fee: 'Tasa fija',
        repayment_rate: 'Tasa de repago',
        merchant: 'Negocio',
        merchant_id: 'Negocio',
        platform_id: 'Plataforma',
        financing_date: 'Fecha Financiación',
        limit_date: 'Fecha límite',
        limit_days: 'Días límite',
        "amount@_gte": "Cantidad mayor a",
        "amount@_lte": "Cantidad menor a",
      },
      states: {
        active: "active",
        new: "new",
        onTime: "on time",
        delayed: "delayed",
        slow: "slow",
        overdue: "overdue",
        chargedOff: "charged off",
        paid: "paid",
        cancelled: "cancelled",
      },
      types: {
        new: 'new',
        refill: 'refill',
        repeat: 'repeat',
        restructure: 'restructure',
      }
    },
    financings: {
      name: 'Financiamiento |||| Financiamientos',
      links: {
        merchant: 'Negocio',
        collections: 'Collections',
        offer: 'Oferta',
        viewStatement: 'Ver declaración'
      },
      fields: {
        collections: 'Collections',
        merchant: 'Negocio',
        merchant_id: 'Negocio',
        status: 'Status',
      }
    },
    FinancialRegimen: {
      name: 'Régimen Financiero |||| Régimenes Financieros',
      fields: {
        name: 'Nombre',
        description: 'Descripción',
        data: {
          country: 'País',
          VAT: {
            value: 'VAT'
          }
        }
      }
    },
    offers: {
      name: 'Oferta |||| Ofertas',
      links: {
        merchant: 'Negocio',
        collections: 'Collections',
        offer: 'Oferta',
        financing: 'Financiamiento',
        financings: 'Financiamientos',
      },
      bulkChangeStatus: {
        title: 'Cambiar status',
        label: 'Cambiar status',
      },
      fields: {
        email: "Email",
        merchant_name: "Nombre del Negocio",
        name: 'Nombre',
        merchant: 'Negocio',
        merchant_id: 'Negocio',
        status: 'Status',
        "merchant#email@_ilike": 'Email',
        "merchant#name@_ilike": "Nombre",
        "amount@_gte": "Monto mayor a",
        "amount@_lte": "Monto menor a",
      }
    },
    Transaction: {
      name: 'Transacción |||| Transacciones',
      links: {
        merchant: 'Negocio',
        financing: 'Financiamiento',
      },
      fields: {
        id: "ID",
        type: 'Tipo',
        timestamp: 'Fecha',
        financing: 'Financiamientos',
        financing_id: 'ID Financiamiento',
        conciliationTransaction: 'Pagos',
        date: 'Fecha',
        sale: 'Venta',
        liquidation: 'Liquidación',
        value: 'Valor',
        volume: 'Volumen',
        platform: 'Plataforma',
        transfer_to_merchant: 'Transferido al Negocio',
        merchant: 'Negocio',
        merchant_id: 'Negocio',
        "type@_eq": "Tipo",
        "timestamp@_gte": "Fecha posterior a",
        "timestamp@_lte": "Fecha antes de",
        "value@_gte": "Valor mayor a",
        "value@_lte": "Valor menor a",
      },
      filters: {
        time: 'Fecha',
        today: 'Hoy',
        this_week: 'Esta semana',
        last_week: 'La última semana',
        this_month: 'Este mes',
        last_month: 'Último mes',
        earlier: 'Antes',
        type: 'Tipo',
        'type@_eq': 'Tipo',
      },
      types: {
        repayment: 'repayment',
        disbursement: 'disbursement',
        chargeback: 'chargeback',
        directPayment: 'direct payment',
        adjustment: 'adjustment',
      }
    },
    collections: {
      name: 'Collection |||| Collections',
      fields: {
        type: 'Tipo',
        collected_at: 'Registrado',
        financing_id: 'Financiamiento',
        merchant_id: 'Negocio',
        offer_id: 'Oferta',
        repayment_amount: 'Valor Repago',
        gross_sales_amount: 'Venta brutas',
        deposited_amount: 'Valor Depositado',
        'type@_eq': 'Tipo',
      },
      filters: {
        time: 'Fecha',
        today: 'Hoy',
        this_week: 'Esta semana',
        last_week: 'La última semana',
        this_month: 'Este mes',
        last_month: 'Último mes',
        earlier: 'Antes',
        type: 'Tipo',
        'type@_eq': 'Tipo',
      },
      types: {
        default: 'default',
        regular: 'regular',
        processed: 'processed',
        direct: 'direct',
      }
    },
    Platform: {
      name: 'Plataforma |||| Plataformas',
      fields: {
        name: 'Nombre',
        merchants: "Negocios",
        financings: "Financiamientos",
        merchantsText: "%{id}",
      }
    },
  },
};

// custom access translations
customSpanishMessages.ra.action.add_filter = 'Filtros'

export default customSpanishMessages;



